import { useEffect } from "react";
import { Button, Checkbox, message, Radio, Space } from "antd";
import { YhBox } from "@/components/YhBox";
import { useReleaseModel } from "../releaseModel";
import { IFoodCategoryOotion } from "@/types/AppEnums";
import { getBaseImgLookUrl } from "@/utils/constants";
import { debounce } from "lodash";
import { RadioChangeEvent } from "antd/lib/radio";
import { ILibraryFields } from "../../library/libraryTypes";
export const MealBox = () => {

    const { initPgCfg,
        dayMeal,
        mealList,
        dayMealList,
        mealSearchParam,
        setMealSearchParam,
        loadLibrary,
        setDayMealList,
        insertMenu,
        updateMenu
    } = useReleaseModel();

    useEffect(() => {
        loadLibrary()
    }, [])

    const onMealType = (item: any, index: number) => {
        setMealSearchParam({ ...mealSearchParam, category: item.value })
        loadLibrary(initPgCfg, { ...mealSearchParam, category: item.value })
    }

    const onFood = (item: any, index: number) => {
        let findIndex = dayMealList.findIndex(i => i.foodId === item.id)
        let newDayMealList = [...dayMealList]
        if (findIndex === -1) {
            newDayMealList.push({
                foodId: item.id,
                cookId: ""
            })
            setDayMealList(newDayMealList)
        } else {
            newDayMealList.splice(findIndex, 1);
            setDayMealList(newDayMealList)
        }
    }
    const onRelease = () => {
        dayMeal?.foods ? updateMenu() : insertMenu()
    }

    //厨师选择
    const handleChef = (e: RadioChangeEvent, item: ILibraryFields) => {
        let findIndex = dayMealList.findIndex(i => i.foodId === item.id)
        if (findIndex === -1) return message.warning("请该选中菜品后在进行厨师选择");
        let newDayMealList = [...dayMealList]
        newDayMealList[findIndex].cookId = e.target.value;
        setDayMealList(newDayMealList)
    }
    return (
        <div className="right">
            <YhBox
                title={""}
                style={{
                    width: "286px",
                    height: "690px",
                    marginRight: "20px",
                }}
            >
                <div className="release">
                    <div className="meal">
                        {IFoodCategoryOotion.map((item, index) => (
                            <p key={index} className={`meal-type ${item.value === mealSearchParam.category ? 'meal-active' : ''}`} onClick={() => onMealType(item, index)}>{item.label}</p>
                        ))}
                    </div>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={debounce(() => { onRelease() }, 900)}
                    >{dayMeal?.foods ? '菜品修改' : '菜品发布'}</Button>
                </div>
            </YhBox>
            <YhBox
                title={""}
                style={{
                    width: "555px",
                    height: "690px",
                    overflowY: "auto"
                }}
            >
                <div className="food">
                    {mealList.filter(fliterItem => dayMealList.map(item => item.foodId).indexOf(fliterItem.id as string) !== -1)
                        .map((item, index) => {
                            return (
                                <div key={index} className="food-item" >
                                    <div className="img" onClick={() => onFood(item, index)}>
                                        <img className="img-detail" src={getBaseImgLookUrl(item.image as string)} alt={item.name} />
                                        <Checkbox className="img-check" checked={true} />
                                    </div>
                                    <div className="message">
                                        <span className="name">{item.name}</span>
                                        <div className="other">
                                            {item.cooks && item.cooks.length > 0 &&
                                                <Radio.Group
                                                    //选中的进行渲染
                                                    value={dayMealList.find(selected => selected.foodId === item.id)?.cookId}
                                                    onChange={(e: RadioChangeEvent) => { e.stopPropagation(); handleChef(e, item) }}
                                                >
                                                    {item.cooks.map((chef: any) => (<Radio value={chef.id} key={chef.id}>{chef.name}</Radio>))}
                                                </Radio.Group>}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    {mealList.filter(fliterItem => dayMealList.map(item => item.foodId).indexOf(fliterItem.id as string) === -1)
                        .map((item, index) => {
                            return (
                                <div key={index} className="food-item" >
                                    <div className="img" onClick={() => onFood(item, index)}>
                                        <img className="img-detail" src={getBaseImgLookUrl(item.image as string)} alt={item.name} />
                                        <Checkbox className="img-check" checked={false} />
                                    </div>
                                    <div className="message">
                                        <span className="name">{item.name}</span>
                                        <div className="other">
                                            {item.cooks && item.cooks.length > 0 &&
                                                <Radio.Group
                                                    //选中的进行渲染
                                                    value={dayMealList.find(selected => selected.foodId === item.id)?.cookId}
                                                    onChange={(e: RadioChangeEvent) => { e.stopPropagation(); handleChef(e, item) }}
                                                >
                                                    {item.cooks.map((chef: any) => (<Radio value={chef.id} key={chef.id}>{chef.name}</Radio>))}
                                                </Radio.Group>}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </YhBox>
        </div>
    )
}